module.exports = __webpack_public_path__ + "img/mc174.dac5ffc4.jpg";